$('.burger__input').on('click', function () {
  $('body').toggleClass('nav-active');
});

$('#main-nav a').on('click', function () {
  $('body').toggleClass('nav-active');
  $('.burger__input').prop('checked', false);
});
